import { styled } from 'styled-components';

export interface PlateStyleProps {
  zoom?: number;
  size?: 'small' | 'large' | 'default';
}

export const RegNumberPlate = styled.div<PlateStyleProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 150px;
  height: ${({ size }) =>
    size === 'small' ? '30px' : size === 'large' ? '50px' : undefined};
  text-transform: uppercase;
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.6);
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);
  background: ${({ theme }) => theme.licensePlateBg};
  border: ${({ theme }) => `1px solid ${theme.licensePlateBorder}`};
  border-radius: 8px;
  padding: 5px 8px;
  font-size: ${({ size }) =>
    size === 'small' ? '10px' : size === 'large' ? '30px' : undefined};
  font-weight: bold;
  white-space: nowrap;
  zoom: ${({ zoom }) => zoom || 1};
`;

export const VinPlate = styled.div<PlateStyleProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  min-width: 220px;
  max-width: 420px;
  min-height: 42px;
  padding: 4px 0;
  color: #101010;
  font-family: 'DIN Alternate', 'Roboto Condensed', 'Arial Narrow', sans-serif;
  font-size: 0.92rem;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-shadow:
    0 1px 0 rgba(255, 255, 255, 0.28),
    0 -1px 0 rgba(0, 0, 0, 0.16);
  border-style: solid;
  border-width: 7px 28px;
  border-image-source: url('/images/metal-plate.png');
  border-image-slice: 180 520 fill;
  border-image-repeat: stretch;
  zoom: ${({ zoom }) => zoom || 1};
`;
